<template>
  <div :is="tag" class="-full-width wt2-expanded-gallery-item">
    <span class="-triangle" :style="triangleStyle"></span>
    <div class="-inner-wrap">
      <wt-close class="-close" @click.native="$emit('close')"></wt-close>
      <wt-player-video :autoPlay="true" :key="video.videoUrl">
        <wt-volume-control group="discover">
          <video
            ref="video"
            :src="mixinSrc(video.videoUrl)"
            :poster="mixinSrc(video.posterPath)"
          />
        </wt-volume-control>
      </wt-player-video>
      <div class="-content">
        <slot></slot>
      </div>
      <transition name="wt2-fade">
        <span v-if="showLeftArrow" class="-arrow -left" @click="prev">
          <i class="wticon wticon-arrow-left" />
        </span>
      </transition>
      <transition name="wt2-fade">
        <span v-if="showRightArrow" class="-arrow -right" @click="next">
          <i class="wticon wticon-arrow-left" />
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
import app from 'app';

export default {
  name: 'expanded-gallery-item',

  props: {
    left: {
      type: Number,
      required: true,
    },
    showRightArrow: {
      type: Boolean,
      default: false,
    },
    showLeftArrow: {
      type: Boolean,
      default: false,
    },
    tag: {
      type: String,
      default: 'div',
    },
    video: {
      type: Object,
      required: true,
    },
    isStoryboard: {
      type: Boolean,
      default: false,
    },
  },

  data: function () {
    return {};
  },

  mounted() {
    this.scrollTimer = setInterval(() => {
      this.scrollToView();
    }, 50);
    this.$el.addEventListener('transitionend', this.removeScrollTimer);
  },

  components: {},

  beforeDestroy() {
    this.removeScrollTimer();
  },

  watch: {
    pauseRequestedAt() {
      this.$refs.video.pause();
    },
  },

  computed: Object.assign(
    app.Vuex.mapState({
      pauseRequestedAt: (state) => state.pauseRequestedAt,
    }),
    {
      triangleStyle() {
        return {
          left: this.left + 'px',
        };
      },
    }
  ),

  methods: Object.assign(
    {
      prev() {
        this.$emit('prev');
      },
      next() {
        this.$emit('next');
      },
      removeScrollTimer() {
        window.clearInterval(this.scrollTimer);
        this.$el.removeEventListener('transitionend', this.scrollToView);
      },
      scrollToView() {
        const offsetTop = this.$el.offsetTop - 120;
        const scrollContainer = this.$el.closest('.-scrollable');
        scrollContainer.scroll({ top: offsetTop });
      },
    },
    {}
  ),
};
</script>
